<script lang="ts">
import type { StudyClosingSlideProps } from '$lib/components/study/slide-layout-types'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

export const STUDY_CLOSING_BACKGROUND =
  'radial-gradient(ellipse 70% 50% at 50% 100%,rgba(17,160,165,.14) 0%,transparent 55%),var(--slide-bg-solid, #030b0a)'

/**
 * End slide: centered headline / lead / tagline (`{@html}`) + CTAs + optional `footerHtml`.
 */
let props: StudyClosingSlideProps = $props()

const headlineStyle = props.headlineStyle ?? 'margin-bottom:.95rem;'
const leadStyle =
  props.leadStyle ??
  'max-width:560px;margin:0 auto .75rem;font-size:1.1rem;line-height:1.7;color:var(--t2);'
const taglineStyle =
  props.taglineStyle ??
  'max-width:660px;margin:0 auto 1.9rem;font-size:1.3rem;font-weight:700;color:var(--slide-fg, #fff);letter-spacing:-.01em;'
</script>

<StudySlide
  id={props.id}
  extraBottom={props.extraBottom}
  background={STUDY_CLOSING_BACKGROUND}
  slideClass="slide--center"
>
  <StudySlideContent maxWidth="690px" textAlign="center">
    <div class="disp" style={headlineStyle}>{@html props.headlineHtml}</div>
    <p style={leadStyle}>{@html props.leadHtml}</p>
    <p style={taglineStyle}>{@html props.taglineHtml}</p>
    <div style="display:flex;gap:.65rem;justify-content:center;flex-wrap:wrap;">
      {#if !props.disableLinks}
        <a href="https://www.imxresearch.com" target="_blank" class="btn">Explore IMX Data &rarr;</a
        >
        <a href="https://www.imxresearch.com/contact" target="_blank" class="btn"
          >Contact Us &rarr;</a
        >
      {/if}
      <button type="button" class="btng" onclick={() => props.goTo(0)}>↩ Restart Story</button>
    </div>
    {#if props.footerHtml}
      {@html props.footerHtml}
    {/if}
  </StudySlideContent>
</StudySlide>
